<mat-form-field appearance="outline" class="full-width">
    <mat-label>{{label|translate}}</mat-label>
    <app-select-search [optionTemplate]="optionTemplate" [displayKey]="'employeeName'" [formControl]="valueControl"
        [data]="doctors" [multiple]="multiple"></app-select-search>
        <button mat-icon-button *ngIf="valueControl.value" matSuffix mat-icon-button aria-label="Clear" 
        (click)="valueControl.reset()">
        <mat-icon>close</mat-icon>
      </button>
</mat-form-field>



<ng-template #optionTemplate let-item>
    <div class="doctor-item">
        <div class="d-flex jusify-content-between doctor-item gap-2">
            <img class="avatar"
                [src]="item.employeeImage ? storageUrl+'/api/files/'+item.employeeImage+'/download': 'assets/images/user/user1.jpg'"
                alt="avatar">
            <div class="flex-fill">
                <div class="d-flex gap-2">
                    <div>
                        {{item.employeeName}}
                    </div>
                    <div class="text-bold text-danger">
                        {{item.clinicPositionName}}
                    </div>
                    <div>
                        {{item.clinicSpecializationName}}
                    </div>
                    <div class="text-bold text-info">
                        {{item.employeeCategoryName}}
                    </div>
                </div>
            </div>
        </div>
    </div>

</ng-template>